import { message, Modal } from 'antd';
import { useAcceptanceViewCalendarInvalidate } from '../../../api/acceptanceViewCalendar';
import { useAcceptanceViewFlatsInvalidate } from '../../../api/acceptanceViewFlats';
import {
  deleteRegistrationCodes,
  useDeleteRegistration,
} from '../../../api/deleteRegistration';

const failedCodes = new Set([
  deleteRegistrationCodes.hasAcceptanceResult,
  deleteRegistrationCodes.hasTimePasssed,
]);

const failedMessages = {
  [deleteRegistrationCodes.hasAcceptanceResult]:
    'Невозможно удалить запись, так как по ней уже есть результат приемки',
  [deleteRegistrationCodes.hasTimePasssed]:
    'Невозможно удалить запись, так как время записи уже прошло',
};

const useDeleteRegistrationHandler = () => {
  const invalidateFlats = useAcceptanceViewFlatsInvalidate();
  const invalidateCalendarView = useAcceptanceViewCalendarInvalidate();

  const { mutateAsync } = useDeleteRegistration({
    onSuccess: (data) => {
      if (failedCodes.has(data.code)) {
        message.error(failedMessages[data.code] ?? 'Не удалось удалить запись');
      }

      invalidateCalendarView();
      invalidateFlats();
    },
  });

  const handler = (intervalId) => {
    Modal.confirm({
      title: 'Удалить запись',
      centered: true,
      onCancel: () => {},
      onOk: async () => {
        await mutateAsync(intervalId);
      },
    });
  };

  return handler;
};

export default useDeleteRegistrationHandler;
